<template>
  <div>
    <div v-if="last_three_episodeNrs">
      <h2>Dómstóll götunnar</h2>
      <span><small>Síðustu 3 þættir</small></span>
    </div>
    <div v-else-if="count">
      <h2>Topp {{ count }}</h2>
    </div>
    <div v-else>
      <h2>Dómstóll götunnar</h2>
    </div>
    <div class="topics-container">
      <div class="topics-heading">
        <div class="topic-title">Umræðuefni</div>
        <div class="topic-avarage" title="Meðaltal">Mtal.</div>
        <div class="topic-count" title="Fjöldi atkvæða">(Atk.)</div>
        <div class="topic-episode" title="Þáttur númer">Nr.</div>
      </div>
      <div class="topic-container" v-for="(topic, idx) in topics" :key="idx">
        <div class="topic-title">
          <span class="episode-nr" v-if="!last_three_episodeNrs">{{ idx + 1 }}.</span>
          <router-link class="content__episodes__numbers" :to="`/episode/${topic.episode_nr}`">
            {{ topic.name }}
          </router-link>
        </div>
        <div class="topic-avarage">{{ topic.avarage }}</div>
        <div class="topic-count">({{ topic.count }})</div>
        <div class="topic-episode">
          <a :href="topic.link" target="_blank">{{ topic.episode_nr }}</a>
        </div>
      </div>
    </div>
    <router-link v-if="!last_three_episodeNrs && count" to="/best-of">Sjá allan listann</router-link>
    <main-footer v-if="!last_three_episodeNrs && !count"></main-footer>
  </div>
</template>

<script>
import {db} from '../main'
import MainFooter from './MainFooter.vue';
import store from '../store';
import {enhanceTopicsWithFeedData} from '../utils';

export default {
  components: {MainFooter},
  name: 'BestOf',
  props: ['last_three_episodeNrs', 'count'],
  data() {
    return {
      db_topics: [],
    }
  },
  firestore() {
    return {
      db_topics: this.last_three_episodeNrs
          ? db.collection('topics').orderBy('avarage', 'desc')
          : this.count
              ? db.collection('topics').orderBy('avarage', 'desc').limit(this.count)
              : db.collection('topics').orderBy('avarage', 'desc')
    }
  },
  computed: {
    topics: function () {
      const enhancedTopics = enhanceTopicsWithFeedData(this.db_topics, store.state.rssFeed);
      if (this.last_three_episodeNrs) {
        return enhancedTopics.filter(t => this.last_three_episodeNrs.filter(nr => nr === t.episode_nr).length > 0);
      }
      return enhancedTopics;
    },
  }
}
</script>

<style scoped>
h2 {
  margin-bottom: 0;
}

.topics-container {
  display: grid;
  grid-template-rows: auto;
  margin-top: 16px;

}

.topics-heading,
.topic-container {
  display: grid;
  grid-template-columns: 5fr 1fr 1.3fr 1fr;
  height: auto;
  align-items: center;
  align-content: center;
  margin-bottom: 16px;
}

.topic-title{
  align-items: center;
  display: flex;
  padding-left: 8px;
}
.topic-title .episode-nr {
  margin-right: 5px;
  font-style: normal;
  font-weight: normal;
}
.topics-heading {
  font-weight: bold;
}

.topics-container > div:nth-child(odd) {
  color: white;
}

.topics-container > div:nth-child(even) {
  color: #a7a59e;
}

.topic-title a {
  text-align: left;
}

.topic-episode a {
  background-color: #3b423b;
  /* color: white; */
  padding: 5px;
  text-decoration: none;
  cursor: pointer;
  border: none;
  border-radius: 8px;
  /* width: auto; */
  display: block;
}

</style>


// WEBPACK FOOTER //
// src/components/BestOf.vue